import {ExternalAppDto} from './external-app-dto.model';

export class ExternalAppsDto{

  apps: ExternalAppDto[] = [];

  constructor(attr: {apps: ExternalAppDto[]}){
    if (attr.apps){
      attr.apps.forEach(rawApp => {
        this.apps.push(new ExternalAppDto(rawApp));
      });
    }
  }

}
